import BookingHeader from "./BookingHeader.jsx";
import { useSelector, shallowEqual } from "react-redux";
import { getCurrentProductURI } from "app/pages/FicheProduit/ficheProduitSelector";
import { getFilteredMarketingBanners } from "app/reducers/partnerSelector.js";
import { getQuotationPriceChangeData } from "app/pages/Booking/Quotation/quotationSelectors.js";

const mapStateToProps = state => {
	return {
		ficheProduitUri: getCurrentProductURI(state),
		resolution: state.resolution,
		brand: state.brand.code,
		marketingBanners: getFilteredMarketingBanners(state),
		quotation: state.quotation,
		booking: state.booking,
		hideHeader: state.navigation.isInApp,
		priceChangeData: getQuotationPriceChangeData(state),
	};
};

const BookingHeaderContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <BookingHeader {...props} {...stateProps} />;
};

export default BookingHeaderContainer;
